export default function LoadingOverlay() {
  return (
    <div className="w-full h-full z-[10000] fixed top-0 left-0 flex items-center text-center bg-transparent">
      <div className="flex-auto">
        <img
          width={60}
          height={60}
          src="/images/aifian-loading.svg"
          className="animate-spin inline-block"
        />
      </div>
    </div>
  )
}
